import { render, staticRenderFns } from "./AudienceModal.vue?vue&type=template&id=feb2832a&scoped=true"
import script from "./AudienceModal.vue?vue&type=script&lang=ts"
export * from "./AudienceModal.vue?vue&type=script&lang=ts"
import style0 from "./AudienceModal.vue?vue&type=style&index=0&id=feb2832a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb2832a",
  null
  
)

export default component.exports